import Base64 from '@/utils/base64'

/**
 * 存储DB数据库
 */
export class DBStorage {
  constructor(dbName, tableName) {
    this.APP_IN_BROWSER = !window.pcmjssdk
    this.KEY_PREFIX = `${dbName}_${tableName}_`
    this.storage = this.hasJsbridge() && new window.jsbridge.JsBridgeDBStorage(dbName, tableName)
  }
  hasJsbridge() {
    return !!window.jsbridge
  }
  async setItem(key, value) {
    if (this.APP_IN_BROWSER) {
      key = this.KEY_PREFIX + key
      try {
        value = Base64.encode(value)
      } catch (error) {
        console.log(error)
      }

      return SLBSDK.nativeCall('SLSetItem', [key, value])
    }
    return this.storage.setItem(key, value)
  }
  async getItem(key) {
    try {
      if (this.APP_IN_BROWSER) {
        key = this.KEY_PREFIX + key
        const ret = await SLBSDK.nativeCall('SLGetItem', [key])
        return Base64.decode(ret)
      }
      const item = await this.storage.getItem(key)
      return item
    } catch (error) {
      console.log('error:',error)
      return ''
    }
  }
  removeItem(key) {
    if (this.APP_IN_BROWSER) {
      return
    }
    return this.storage.deleteItem(key)
  }
  deleteTable() {
    if (this.APP_IN_BROWSER) {
      return
    }
    return this.storage.deleteTable()
  }
}
